<div class="flex h-full flex-col items-center justify-center px-6 py-16">
  <div class="max-w-sm text-center">
    <div
      class="bg-accent-interactive mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full">
      <i class="ph-bold ph-wrench text-accent-main text-3xl"></i>
    </div>

    <h2 class="mb-2">{{ 'error_pages.under_construction.title' | translate }}</h2>
    <p class="text-text-secondary mb-6 text-sm">
      {{ 'error_pages.under_construction.description' | translate }}
    </p>

    <a href="/" class="btn-primary inline-flex items-center gap-2 rounded-sm px-4 py-2">
      <i class="ph-bold ph-house"></i>
      {{ 'error_pages.redirect' | translate }}
    </a>
  </div>
</div>
